import { ref, readonly } from 'vue'

import api from '@/lib/api'

export interface FeatureFlags {
  brain: boolean
  reports: boolean
  presentations: boolean
  org_chart: boolean
  dashboard: boolean
  outbound: boolean
  estimation: boolean
  modeler: boolean
  crm: boolean
}

const flags = ref<FeatureFlags>({
  brain: false,
  reports: false,
  presentations: false,
  org_chart: false,
  dashboard: false,
  outbound: false,
  estimation: false,
  modeler: false,
  crm: false,
})
const loaded = ref(false)

async function fetchFlags(): Promise<void> {
  const { data } = await api.get('/api/features')
  flags.value = data.data ?? data
  loaded.value = true
}

export function useFeatureFlags() {
  const loadFlags = async () => {
    if (loaded.value) return
    try {
      await fetchFlags()
    } catch {
      // fail closed — all flags stay false
    }
  }

  const refreshFlags = async () => {
    try {
      await fetchFlags()
    } catch {
      // fail closed
    }
  }

  return {
    flags: readonly(flags),
    loadFlags,
    refreshFlags,
  }
}
